import React from 'react'
import Toolbar from './Toolbar'
import CloseButtonContainer from './CloseButtonContainer'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
	title: {
		flex: 1,
		alignSelf: 'center'
	},
	closeButton: {
		marginLeft: theme.spacing.unit * -2
	}

})

const TitleToolbar = ({ title, children, classes }) => (
	<Toolbar>
		<CloseButtonContainer className={classes.closeButton} />
		<Typography variant="title" color="inherit" className={classes.title}>
			{title}
		</Typography>
		{children}
	</Toolbar>
)

export default withStyles(styles)(TitleToolbar)



// WEBPACK FOOTER //
// ./src/components/Page/TitleToolbar.js